import { render, staticRenderFns } from "./OrticInputMaskControl.vue?vue&type=template&id=6c9084e3&"
import script from "./OrticInputMaskControl.vue?vue&type=script&lang=js&"
export * from "./OrticInputMaskControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports